import React from 'react';

const Global = () => {
  return (
    <div>
      <h1>グローバル</h1>
      <p>ここでは、プログラミングやAI、Web開発の学習内容について紹介します。</p>
    </div>
  );
};

export default Global;